module.exports = __webpack_public_path__ + "img/news_3.1c15be6f.jpg";